import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '../lib/api';

export type EstadoCuenta = 'activa' | 'sin_verificar' | 'bloqueada';

/** Una cuenta de la web (Cognito) cruzada con su ficha del CRM. */
export interface Cuenta {
  username: string;
  email: string;
  nombre?: string;
  telefono?: string;
  perfiles: string[];
  client_id: string | null;
  alta: string; // AAAA-MM-DD
  estado: EstadoCuenta;
  equipo: boolean;
  soy_yo: boolean;
  actividad: { viviendas: number; contratos: number; incidencias: number; facturas: number };
}

export interface ResumenCuentas {
  activas: number;
  altas_30_dias: number;
  sin_verificar: number;
  bloqueadas: number;
}

/** Solo admin. */
export function useCuentas() {
  return useQuery<{ items: Cuenta[]; resumen: ResumenCuentas }>({
    queryKey: ['cuentas'],
    queryFn: async () => (await api.get('/crm/cuentas')).data,
  });
}

export function useBloquear() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async ({ username, bloqueada }: { username: string; bloqueada: boolean }) =>
      (await api.put(`/crm/cuentas/${encodeURIComponent(username)}`, { bloqueada })).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['cuentas'] }),
  });
}
